var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-card',{attrs:{"card-class":['dataCard', _vm.cardClass],"title":_vm.title,"title-class":"py-1","content-class":"px-6 pb-6"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }